import { createClient } from '@supabase/supabase-js'
import { Database } from '@repo/supabase'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

console.log('🔍 Environment variables check:')
console.log('VITE_SUPABASE_URL:', supabaseUrl ? '✓ Set' : '❌ Missing')
console.log('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✓ Set' : '❌ Missing')

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!')
  throw new Error('Missing Supabase environment variables')
}

console.log('✅ Creating Supabase client...')
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)